import React from 'react';
import {withStyles, makeStyles} from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import {useSubheader} from "../../../../_metronic/layout";
import AddIcon from '@material-ui/icons/Add';
import CreateUserModal from '../../../components/Modals/Users/CreateUserModal'
import UserList from '../../../components/Modules/Users/UserList'
import useLocationData from "../../../hooks/DataProvider/useLocationData";
import Divider from "@material-ui/core/Divider";
import {getItemById} from "../../../utils/helpers";
import TextField from "../../../components/Ui/TextField";
import {Field, FieldArray, Formik} from "formik";
import * as Yup from 'yup';
import clsx from "clsx";
import {GET_VILLES, UPDATE_DONNEE_GEOGRAPHIQUE} from "../../../api/Api";
import axios from 'axios';
import CircularProgress from "@material-ui/core/CircularProgress";
import BootstrapLoadingButton from "../../../components/Ui/BootstrapLoadingButton";
import {toast} from "react-toastify";

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing(3),
        overflowX: 'auto',
    },
    locationItem: {
        '&': {
            opacity: 0.3
        },
        '&.active': {
            opacity: 1
        },
        '&:hover': {
            opacity: 1
        },
    },
    table: {
        minWidth: 700,
    },
}));


function entierAleatoire(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

export default function LocationsPage() {
    const classes = useStyles();

    const suhbeader = useSubheader();
    suhbeader.setTitle("Données géographique");

    const [villes, setVilles] = React.useState([])
    const [isLoadingVilles, setIsLoadingVilles] = React.useState(false)

    const [selectedVille, setSelectedVille] = React.useState();
    const [selectedVilleIndex, setSelectedVilleIndex] = React.useState();
    const [selectedCommune, setSelectedCommune] = React.useState();
    const [selectedCommuneIndex, setSelectedCommuneIndex] = React.useState();
    const [selectedQuartier, setSelectedQuartier] = React.useState();
    const [selectedQuartierIndex, setSelectedQuartierIndex] = React.useState();


    const [inputVille, setInputVille] = React.useState();
    const [inputCommune, setInputCommune] = React.useState();
    const [inputQuartier, setInputQuartier] = React.useState();
    const [inputRue, setInputRue] = React.useState();

    async function updateLocations(values, formikHelpers) {

        await axios.post(
            UPDATE_DONNEE_GEOGRAPHIQUE,
            {
                villes: values.villes
            }
        );

        setSelectedVilleIndex();
        setSelectedCommuneIndex();
        setSelectedQuartierIndex();
        setSelectedQuartierIndex();

        formikHelpers.setSubmitting(false)

        await loadVilles();

        toast.success('Les données géographique ont été mise à jour', {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });  
        

    }

    async function loadVilles() {

        setIsLoadingVilles(true)

        axios
            .get(
                GET_VILLES
            ).then(
            ({data}) => {

                setVilles(data);

            }
        ).finally(
            () => {
                setIsLoadingVilles(false);
            }
        )

    }

    React.useEffect(() => {
        loadVilles();
    }, []);

    return (

        <div>
            <div className={`card card-custom`}>
                {/* Header */}

                {/* Body */}
                <Formik
                    initialValues={{
                        villes
                    }}
                    enableReinitialize={true}
                    onSubmit={(values, helpers) => {
                        updateLocations(values, helpers)
                    }}

                >

                    {
                        (rootFormikHelpers) => {
                            return (

                                <>
                                    <div className="card-header border-0">
                                        <h3 className="card-title font-weight-bolder text-dark text-gray">
                                            Configuration des points géographique

                                            {
                                                isLoadingVilles && (
                                                    <CircularProgress/>
                                                )
                                            }

                                        </h3>
                                        <div className="card-toolbar">

                                            <BootstrapLoadingButton isLoading={rootFormikHelpers.isSubmitting}
                                                                    onClick={() => {
                                                                        rootFormikHelpers.submitForm();
                                                                    }}
                                                                    className="btn btn-light-primary font-weight-bolder mr-2">
                                                Enregistrer
                                                <AddIcon/>
                                            </BootstrapLoadingButton>

                                        </div>
                                    </div>

                                    <div
                                        className="card-body pt-2">
                                        <div className={'row'}>

                                            <div className="col-3 bg-secondary">

                                                <div className="text-primary h4 font-weight-bold px-5 py-5">
                                                    Villes
                                                </div>


                                                <FieldArray name={'villes'}
                                                            render={(arrayHelpers) => {
                                                                return (
                                                                    <div>

                                                                        <div>
                                                                            <Formik
                                                                                initialValues={{
                                                                                    libelle: ''
                                                                                }}
                                                                                validationSchema={Yup.object().shape({
                                                                                    libelle: Yup.string().required('Vous devez saisir le libelle')
                                                                                })}
                                                                                onSubmit={(values, helpers) => {
                                                                                    helpers.setSubmitting(false)
                                                                                    arrayHelpers.push(
                                                                                        {
                                                                                            id: rootFormikHelpers.values.villes.length + 1,
                                                                                            libelle: values.libelle,
                                                                                            added: true,
                                                                                            communes: []
                                                                                        }
                                                                                    );

                                                                                    setInputVille('');
                                                                                    setSelectedVilleIndex();
                                                                                    setSelectedCommuneIndex();
                                                                                    setSelectedQuartierIndex();
                                                                                }}
                                                                            >
                                                                                {
                                                                                    (formikHelpers) => {
                                                                                        return (
                                                                                            <div
                                                                                                className={'row bg-white no-gutters px-3 py-3 d-flex align-items-center'}>

                                                                                                <div className={'col'}>

                                                                                                    <Field
                                                                                                        name={'libelle'}
                                                                                                        component={TextField}
                                                                                                        noLabel={true}
                                                                                                        onChange={(e) => {
                                                                                                            formikHelpers.handleChange(e)
                                                                                                            setInputVille(e.target.value)
                                                                                                        }}
                                                                                                        placeholder={'Ajoutez une ville'}
                                                                                                    />
                                                                                                </div>

                                                                                                <div
                                                                                                    className={'col-auto ml-1'}>

                                                                                                    <div
                                                                                                        onClick={formikHelpers.submitForm}
                                                                                                        className={'btn btn-icon btn-secondary'}>
                                                                                                        <i className={'flaticon-add'}></i>
                                                                                                    </div>

                                                                                                </div>


                                                                                            </div>
                                                                                        )
                                                                                    }
                                                                                }
                                                                            </Formik>
                                                                        </div>


                                                                        {
                                                                            rootFormikHelpers.values.villes && rootFormikHelpers.values.villes
                                                                                .map(
                                                                                    (ville, index) => {

                                                                                        if (inputVille && !ville.libelle.toLowerCase().includes(inputVille.toLowerCase()))
                                                                                            return null;

                                                                                        return (
                                                                                            <div
                                                                                                className={clsx(classes.locationItem, {['active']: index == selectedVilleIndex})}
                                                                                                key={ville.id}>

                                                                                                <div
                                                                                                    key={ville.id}
                                                                                                    className={`bg-white ${clsx({
                                                                                                        ['bg-light-danger']: !!ville.deleted,
                                                                                                        ['bg-light-success']: !!ville.added,
                                                                                                        ['bg-light-info']: !!ville.updated,
                                                                                                    })} text-primary row no-gutters px-3 d-flex align-items-center`}>

                                                                                                    <div
                                                                                                        className={'col card-title my-0 py-5 pl-3 text-primary'}>

                                                                                                        <Field
                                                                                                            name={`villes.${index}.libelle`}
                                                                                                            component={TextField}
                                                                                                            key={ville.id}
                                                                                                            noLabel={true}
                                                                                                            onFocus={()=>{
                                                                                                                setSelectedVilleIndex(index)
                                                                                                                setSelectedCommuneIndex();
                                                                                                                setSelectedQuartierIndex();
                                                                                                            }}
                                                                                                        />

                                                                                                    </div>

                                                                                                    <div
                                                                                                        onClick={() => {
                                                                                                            rootFormikHelpers.setFieldValue(`villes.${index}.deleted`, !ville.deleted);
                                                                                                        }}
                                                                                                        className={'btn btn-icon small btn-light-danger'}>
                                                                                                        <i className="flaticon-delete"/>
                                                                                                    </div>


                                                                                                    <div
                                                                                                        onClick={() => {
                                                                                                            setSelectedVille(ville.id)

                                                                                                            setSelectedCommuneIndex();
                                                                                                            setSelectedQuartierIndex();
                                                                                                            setSelectedVilleIndex(index)

                                                                                                        }}
                                                                                                        className={'btn btn-icon small btn-light-primary'}>
                                                                                                        <i className="flaticon2-right-arrow"/>
                                                                                                    </div>

                                                                                                </div>

                                                                                                <Divider/>

                                                                                            </div>
                                                                                        )
                                                                                    }
                                                                                )
                                                                        }

                                                                    </div>
                                                                )
                                                            }}
                                                />


                                            </div>
                                            <div className="col-3 bg-secondary">

                                                <div className="text-primary h4 font-weight-bold px-5 py-5">
                                                    Communes
                                                </div>

                                                <FieldArray
                                                    name={`villes.${selectedVilleIndex}.communes`}
                                                    render={(arrayHelpers) => {
                                                        return (
                                                            <div>

                                                                {
                                                                    selectedVilleIndex !== undefined && (

                                                                        <div>
                                                                            <Formik
                                                                                initialValues={{
                                                                                    libelle: ''
                                                                                }}
                                                                                validationSchema={Yup.object().shape({
                                                                                    libelle: Yup.string().required('Vous devez saisir le libelle')
                                                                                })}
                                                                                onSubmit={(values, helpers) => {
                                                                                    helpers.setSubmitting(false)

                                                                                    arrayHelpers.push(
                                                                                        {
                                                                                            id: rootFormikHelpers.values.villes[selectedVilleIndex].communes.length + 1,
                                                                                            libelle: values.libelle,
                                                                                            ville_id: rootFormikHelpers.values.villes[selectedVilleIndex].id,
                                                                                            added: true,
                                                                                            quartiers: []
                                                                                        }
                                                                                    );

                                                                                    setInputCommune('');
                                                                                    setSelectedCommuneIndex();
                                                                                    setSelectedQuartierIndex();

                                                                                }}
                                                                            >
                                                                                {
                                                                                    (formikHelpers) => {
                                                                                        return (
                                                                                            <div
                                                                                                className={'row bg-white no-gutters px-3 py-3 d-flex align-items-center'}>

                                                                                                <div className={'col'}>

                                                                                                    <Field
                                                                                                        name={'libelle'}
                                                                                                        component={TextField}
                                                                                                        noLabel={true}
                                                                                                        onChange={(e) => {
                                                                                                            formikHelpers.handleChange(e)
                                                                                                            setInputCommune(e.target.value)
                                                                                                        }}
                                                                                                        placeholder={'Ajoutez une ville'}
                                                                                                    />
                                                                                                </div>

                                                                                                <div
                                                                                                    className={'col-auto ml-1'}>

                                                                                                    <div
                                                                                                        onClick={formikHelpers.submitForm}
                                                                                                        className={'btn btn-icon btn-secondary'}>
                                                                                                        <i className={'flaticon-add'}></i>
                                                                                                    </div>

                                                                                                </div>


                                                                                            </div>
                                                                                        )
                                                                                    }
                                                                                }
                                                                            </Formik>
                                                                        </div>

                                                                    )
                                                                }


                                                                {
                                                                    selectedVilleIndex != undefined && rootFormikHelpers.values.villes[selectedVilleIndex].communes.map(
                                                                        (commune, index) => {


                                                                            if (inputCommune && !commune.libelle.toLowerCase().includes(inputCommune.toLowerCase()))
                                                                                return null;


                                                                            return (
                                                                                <div
                                                                                    className={clsx(classes.locationItem, {['active']: index == selectedCommuneIndex})}
                                                                                    key={commune.id}>

                                                                                    <div
                                                                                        className={`bg-white ${clsx({
                                                                                            ['bg-light-danger']: !!commune.deleted,
                                                                                            ['bg-light-success']: !!commune.added,
                                                                                            ['bg-light-info']: !!commune.updated,
                                                                                        })} text-primary row no-gutters px-3 d-flex align-items-center`}>

                                                                                        <div
                                                                                            className={'col card-title my-0 py-5 pl-3 text-primary'}>

                                                                                            <Field
                                                                                                name={`villes.${selectedVilleIndex}.communes.${index}.libelle`}
                                                                                                component={TextField}
                                                                                                noLabel={true}
                                                                                                onFocus={()=>{
                                                                                                    setSelectedCommuneIndex(index)
                                                                                                    setSelectedQuartierIndex();
                                                                                                }}
                                                                                            />

                                                                                        </div>

                                                                                        <div onClick={() => {
                                                                                            rootFormikHelpers.setFieldValue(`villes.${selectedVilleIndex}.communes.${index}.deleted`, !commune.deleted);
                                                                                        }}
                                                                                             className={'btn btn-icon small btn-light-danger'}>
                                                                                            <i className="flaticon-delete"/>
                                                                                        </div>

                                                                                        <div onClick={() => {
                                                                                            setSelectedCommune(commune.id)

                                                                                            setSelectedQuartierIndex();
                                                                                            setSelectedCommuneIndex(index)
                                                                                        }}
                                                                                             className={'btn btn-icon small btn-light-primary'}>
                                                                                            <i className="flaticon2-right-arrow"/>
                                                                                        </div>

                                                                                    </div>

                                                                                    <Divider/>

                                                                                </div>
                                                                            )
                                                                        }
                                                                    )
                                                                }

                                                            </div>

                                                        )
                                                    }}
                                                />


                                            </div>

                                            <div className="col-3 bg-secondary">

                                                <div className="text-primary h4 font-weight-bold px-5 py-5">
                                                    Quartier
                                                </div>

                                                <div>


                                                    <FieldArray
                                                        name={`villes.${selectedVilleIndex}.communes.${selectedCommuneIndex}.quartiers`}
                                                        render={(arrayHelpers) => {
                                                            return (

                                                                <div>


                                                                    {
                                                                        selectedCommuneIndex != undefined && (

                                                                            <div>
                                                                                <Formik
                                                                                    initialValues={{
                                                                                        libelle: ''
                                                                                    }}
                                                                                    validationSchema={Yup.object().shape({
                                                                                        libelle: Yup.string().required('Vous devez saisir le libelle')
                                                                                    })}
                                                                                    onSubmit={(values, helpers) => {
                                                                                        helpers.setSubmitting(false)

                                                                                        arrayHelpers.push(
                                                                                            {
                                                                                                id: rootFormikHelpers.values.villes[selectedVilleIndex].communes[selectedCommuneIndex].quartiers.length + 1,
                                                                                                libelle: values.libelle,
                                                                                                ville_id: rootFormikHelpers.values.villes[selectedVilleIndex].communes[selectedCommuneIndex].id,
                                                                                                added: true,
                                                                                                rues: []
                                                                                            }
                                                                                        );

                                                                                        setInputQuartier('');
                                                                                        setSelectedQuartierIndex();

                                                                                    }}
                                                                                >
                                                                                    {
                                                                                        (formikHelpers) => {
                                                                                            return (
                                                                                                <div
                                                                                                    className={'row bg-white no-gutters px-3 py-3 d-flex align-items-center'}>

                                                                                                    <div
                                                                                                        className={'col'}>

                                                                                                        <Field
                                                                                                            name={'libelle'}
                                                                                                            component={TextField}
                                                                                                            noLabel={true}
                                                                                                            onChange={(e) => {
                                                                                                                formikHelpers.handleChange(e)
                                                                                                                setInputQuartier(e.target.value)
                                                                                                            }}
                                                                                                            placeholder={'Ajoutez un quartier'}
                                                                                                        />

                                                                                                    </div>

                                                                                                    <div
                                                                                                        className={'col-auto ml-1'}>

                                                                                                        <div
                                                                                                            onClick={formikHelpers.submitForm}
                                                                                                            className={'btn btn-icon btn-secondary'}>
                                                                                                            <i className={'flaticon-add'}></i>
                                                                                                        </div>

                                                                                                    </div>


                                                                                                </div>
                                                                                            )
                                                                                        }
                                                                                    }
                                                                                </Formik>
                                                                            </div>

                                                                        )
                                                                    }


                                                                    {
                                                                        selectedCommuneIndex != undefined && rootFormikHelpers.values.villes[selectedVilleIndex].communes[selectedCommuneIndex].quartiers.map(
                                                                            (quartier, index) => {

                                                                                if (inputQuartier && !quartier.libelle.toLowerCase().includes(inputQuartier.toLowerCase()))
                                                                                    return null;

                                                                                return (
                                                                                    <div key={quartier.id}>

                                                                                        <div
                                                                                            className={`bg-white ${clsx({
                                                                                                ['bg-light-danger']: !!quartier.deleted,
                                                                                                ['bg-light-success']: !!quartier.added,
                                                                                                ['bg-light-info']: !!quartier.updated,
                                                                                            })} text-primary row no-gutters px-3 d-flex align-items-center`}>

                                                                                            <div
                                                                                                className={'col card-title my-0 py-5 pl-3 text-primary'}>

                                                                                                <Field
                                                                                                    name={`villes.${selectedVilleIndex}.communes.${selectedCommuneIndex}.quartiers.${index}.libelle`}
                                                                                                    component={TextField}
                                                                                                    noLabel={true}
                                                                                                    onFocus={()=>{
                                                                                                        setSelectedQuartierIndex(index)
                                                                                                    }}
                                                                                                />

                                                                                            </div>


                                                                                            <div onClick={() => {
                                                                                                rootFormikHelpers.setFieldValue(`villes.${selectedVilleIndex}.communes.${selectedCommuneIndex}.quartiers.${index}.deleted`, !quartier.deleted);
                                                                                            }}
                                                                                                 className={'btn btn-icon small btn-light-danger'}>
                                                                                                <i className="flaticon-delete"/>
                                                                                            </div>

                                                                                            <div onClick={() => {
                                                                                                setSelectedQuartier(quartier.id)
                                                                                                setSelectedQuartierIndex(index)
                                                                                            }}
                                                                                                 className={'btn btn-icon small btn-light-primary'}>
                                                                                                <i className="flaticon2-right-arrow"/>
                                                                                            </div>

                                                                                        </div>

                                                                                        <Divider/>

                                                                                    </div>
                                                                                )
                                                                            }
                                                                        )
                                                                    }

                                                                </div>

                                                            )
                                                        }}
                                                    />


                                                </div>

                                            </div>

                                            <div className="col-3 bg-secondary">

                                                <div className="text-primary h4 font-weight-bold px-5 py-5">
                                                    Rues
                                                </div>

                                                <div>

                                                    {
                                                        selectedQuartierIndex != undefined && rootFormikHelpers.values.villes[selectedVilleIndex].communes[selectedCommuneIndex].quartiers[selectedQuartierIndex].rues.length == 0 && (
                                                            <div className={'text-dark font-weight-light@'}>
                                                                Aucune rue dans ce quartier enregistré
                                                            </div>
                                                        )
                                                    }

                                                    <FieldArray
                                                        name={`villes.${selectedVilleIndex}.communes.${selectedCommuneIndex}.quartiers.${selectedQuartierIndex}.rues`}
                                                        render={(arrayHelpers) => (
                                                            <div>

                                                                {
                                                                    selectedQuartierIndex != undefined && (

                                                                        <div>
                                                                            <Formik
                                                                                initialValues={{
                                                                                    libelle: ''
                                                                                }}
                                                                                validationSchema={Yup.object().shape({
                                                                                    libelle: Yup.string().required('Vous devez saisir le libelle')
                                                                                })}
                                                                                onSubmit={(values, helpers) => {
                                                                                    helpers.setSubmitting(false)
                                                                                    arrayHelpers.push(
                                                                                        {
                                                                                            id: rootFormikHelpers.values.villes[selectedVilleIndex].communes[selectedCommuneIndex].quartiers[selectedQuartierIndex].rues.length + 1,
                                                                                            libelle: values.libelle,
                                                                                            ville_id: rootFormikHelpers.values.villes[selectedVilleIndex].communes[selectedCommuneIndex].id,
                                                                                            added: true,
                                                                                            rues: []
                                                                                        }
                                                                                    );

                                                                                    setInputRue('');

                                                                                }}
                                                                            >
                                                                                {
                                                                                    (formikHelpers) => {
                                                                                        return (
                                                                                            <div
                                                                                                className={'row bg-white no-gutters px-3 py-3 d-flex align-items-center'}>

                                                                                                <div className={'col'}>

                                                                                                    <Field
                                                                                                        name={'libelle'}
                                                                                                        component={TextField}
                                                                                                        noLabel={true}
                                                                                                        onChange={(e) => {
                                                                                                            formikHelpers.handleChange(e)
                                                                                                            setInputRue(e.target.value)
                                                                                                        }}
                                                                                                        placeholder={'Ajoutez une ville'}
                                                                                                    />
                                                                                                </div>

                                                                                                <div
                                                                                                    className={'col-auto ml-1'}>

                                                                                                    <div
                                                                                                        onClick={formikHelpers.submitForm}
                                                                                                        className={'btn btn-icon btn-secondary'}>
                                                                                                        <i className={'flaticon-add'}></i>
                                                                                                    </div>

                                                                                                </div>


                                                                                            </div>
                                                                                        )
                                                                                    }
                                                                                }
                                                                            </Formik>
                                                                        </div>

                                                                    )
                                                                }


                                                                {
                                                                    selectedQuartierIndex != undefined && rootFormikHelpers.values.villes[selectedVilleIndex].communes[selectedCommuneIndex].quartiers[selectedQuartierIndex].rues.map(
                                                                        (rue, index) => {

                                                                            if (inputRue && !rue.libelle.toLowerCase().includes(inputRue.toLowerCase()))
                                                                                return null;

                                                                            return (
                                                                                <div key={rue.id}>

                                                                                    <div
                                                                                        className={`bg-white ${clsx({
                                                                                            ['bg-light-danger']: !!rue.deleted,
                                                                                            ['bg-light-success']: !!rue.added,
                                                                                            ['bg-light-info']: !!rue.updated,
                                                                                        })} text-primary row no-gutters px-3 d-flex align-items-center`}>

                                                                                        <div
                                                                                            className={'col card-title my-0 py-5 pl-3 text-primary'}>

                                                                                            <Field
                                                                                                name={`villes.${selectedVilleIndex}.communes.${selectedCommuneIndex}.quartiers.${selectedQuartierIndex}.rues.${index}.libelle`}
                                                                                                component={TextField}
                                                                                                noLabel={true}
                                                                                                onFocus={()=>{
                                                                                                }}
                                                                                            />

                                                                                        </div>


                                                                                        <div onClick={() => {
                                                                                            rootFormikHelpers.setFieldValue(`villes.${selectedVilleIndex}.communes.${selectedCommuneIndex}.quartiers.${selectedQuartierIndex}.rues.${index}.deleted`, !rue.deleted);
                                                                                        }}
                                                                                             className={'btn btn-icon small btn-light-danger'}>
                                                                                            <i className="flaticon-delete"/>
                                                                                        </div>


                                                                                        <div onClick={() => {

                                                                                        }}
                                                                                             className={'btn btn-icon small btn-light-danger'}>
                                                                                            <i className="flaticon-delete"/>
                                                                                        </div>

                                                                                    </div>

                                                                                    <Divider/>

                                                                                </div>
                                                                            )
                                                                        }
                                                                    )
                                                                }

                                                            </div>
                                                        )}/>


                                                </div>

                                            </div>

                                        </div>
                                    </div>

                                </>


                            )
                        }
                    }

                </Formik>

            </div>

        </div>

    );
}
